import { Injectable, EventEmitter } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { PathNode, PathConfiguration, } from '@mprep/shared/data/models'
import { PathService, PathConfigurationService } from '@mprep/shared/data/services'
import { ActivePathService } from '@mprep/shared/lib/data/services'

@Injectable()
export class AppStateService {

  public get pathConfiguration() {
    return this._pathConfiguration
  }

  public get path() {
    return this._path
  }

  private _pathConfiguration: PathConfiguration
  private _path: PathNode
  public pathConfigurationChanged: EventEmitter<PathConfiguration> = new EventEmitter<PathConfiguration>()

  public constructor(
    private _pathService: PathService,
    private _pathConfigurationService: PathConfigurationService,
    private _activePathService: ActivePathService
  ) {}

  public setDefaultState(): Observable<any> {
    return this._setDefaultPathObservable().map((path) => {
      return this._pathChanged(path)
    }).flatMap((observable) => observable)
  }

  public setPath(path) {
    if (this._path !== path) {
      this._path = path
      return this._pathChanged(path)
    } else {
      return Observable.of(this._pathConfiguration)
    }
  }

  private _setDefaultPathObservable(): Observable<PathNode> {
    return this._pathService.getAssignedPath().map((path) => this._path = path)
  }

  private _pathChanged(path: PathNode) {
    return Observable.forkJoin([
      this._setPathConfiguration(path),
      this._activePathService.saveActivePath(path)
    ]).map((results) => results[0])
  }

  private _setPathConfiguration(path: PathNode): Observable<any> {
    return this._pathConfigurationService.findModelsBy({rootPathNode: path}, ['rootPathNode', 'rootMenuItem'])
      .map((pathConfigurations) => {
        this._pathConfiguration = pathConfigurations[0]
        this.pathConfigurationChanged.emit(this._pathConfiguration)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/app-state/app-state.service.ts